const detectUndefined = (value: string): boolean => value.includes('undefined')

export default detectUndefined
